import React from "react";
import { Box, Button, Fab, Grid, IconButton, List, ListItem, ListItemIcon, ListItemText, Stack, Tooltip, Typography } from "@mui/material";
import { t, Trans } from "@lingui/macro";
import * as Yup from "yup";
import { withUseFormHook, } from "@sinossi/mates-react-library";
import { UseFormReturn } from "react-hook-form";
import ZplayFormField from "commons/fields/zplay-form-field";
import ZplayDatePicker from "commons/fields/zplay-date-picker";
import { CreateAndEditContentListProps, CreateAndEditContentListState } from "./models";
import { ZPlayAutocomplete, ZPlayChipList, ZPlayMultilineTextField } from "commons/fields";
import { CreateContentListRequest } from "models/request";
import { ContentDescription } from "models";
import ZplayCheckbox from "commons/fields/zplay-checkbox";
import AddIcon from "@mui/icons-material/Add";
import ClearIcon from '@mui/icons-material/Clear';
import CircleIcon from "@mui/icons-material/Circle";
import ErrorIcon from "@mui/icons-material/Error";
import { ThumbUpload } from "../../content/create-and-edit-content-detail-form/metadata-section";
import { EditContentListRequest } from "models/request/edit-content-list-request";

const CreateAndEditContentListFormSchema = Yup.object().shape({
});

class CreateAndEditContentList extends React.Component<CreateAndEditContentListProps & UseFormReturn, CreateAndEditContentListState> {

    constructor(props: any) {
        super(props);

        this.state = {
            titles: this.props.contentList ? this.props.contentList.title : [],
            descriptions: this.props.contentList ? this.props.contentList.description : [],
            titleError: false,
            languageError: false,
            selectedAwards: this.props.contentList ? this.props.contentList.awards : [],
            selectedCountries: this.props.contentList ? this.props.contentList.countries : [],
            selectedGenres: this.props.contentList ? this.props.contentList.genres : [],
            selectedFestivals: this.props.contentList ? this.props.contentList.festivals : [],
            selectedLanguages: this.props.contentList ? this.props.contentList.languages : [],
            selectedTags: this.props.contentList ? this.props.contentList.tags : [],
            isMenuEntry: this.props.contentList ? this.props.contentList.isMenuEntry : false,
            awards: this.props.collectionsList.awardList.list,
            countries: this.props.collectionsList.countryList.list,
            genres: this.props.collectionsList.genreList.list,
            festival: this.props.collectionsList.festivalList.list,
            languages: this.props.collectionsList.languageList.list,
            tags: this.props.collectionsList.tagList.list,
            formFlag: false,
            isThumbUploaded: this.props.contentList && this.props.contentList.thumbnailServingUrl && this.props.contentList.thumbnailData ? true : false,
            isThumbUpdated: false,
            fileImg: null,
            fileImgName: this.props.contentList && this.props.contentList.thumbnailData ? this.props.contentList.thumbnailData.fileName : null,
            fileImgURL: this.props.contentList && this.props.contentList.thumbnailServingUrl ? this.props.contentList.thumbnailServingUrl : null,
        }

    }

    componentDidMount() {
        if (this.props.contentList) {
            this.setFormValues();
        }

        this.setState(() => ({ formFlag: true }));
    }

    private setFormValues() {
        this.props.setValue('priority', this.props.contentList!.priority)
        this.props.setValue('featuredFrom', this.props.contentList!.featuredFrom)
        this.props.setValue('featuredTo', this.props.contentList!.featuredTo)
        this.props.setValue('isMenuEntry', this.props.contentList!.isMenuEntry)
    }


    private submitForm = (values: any) => {

        if (!this.props.contentList) {

            let request: CreateContentListRequest = {
                title: this.state.titles,
                description: this.state.descriptions,
                priority: Number(values.priority) ? Number(values.priority) : 0,
                featuredFrom: values.featuredFrom,
                featuredTo: values.featuredTo,
                awards: this.state.selectedAwards,
                countries: this.state.selectedCountries,
                festivals: this.state.selectedFestivals,
                genres: this.state.selectedGenres,
                tags: this.state.selectedTags,
                languages: this.state.selectedLanguages,
                isMenuEntry: this.state.isMenuEntry,
                thumbnailData: this.state.fileImg,
            }
            this.props.onSubmit(request);

        } else {

            let request: EditContentListRequest = {
                contentList: this.props.contentList,
                thumbnailData: this.state.isThumbUpdated ? this.state.fileImg : null
            }

            request.contentList.title = this.state.titles
            request.contentList.description = this.state.descriptions
            request.contentList.priority = Number(values.priority) ? Number(values.priority) : 0
            request.contentList.featuredFrom = values.featuredFrom
            request.contentList.featuredTo = values.featuredTo
            request.contentList.awards = this.state.selectedAwards
            request.contentList.countries = this.state.selectedCountries
            request.contentList.festivals = this.state.selectedFestivals
            request.contentList.genres = this.state.selectedGenres
            request.contentList.tags = this.state.selectedTags
            request.contentList.languages = this.state.selectedLanguages
            request.contentList.thumbnailData = this.state.fileImg
            request.contentList.isMenuEntry = this.state.isMenuEntry

            this.props.onSubmit(request);
        }
    };

    private addTitle = (): void => {

        this.setState(() => ({
            titleError: false,
            languageError: false
        }));

        let isoCode = this.props.collectionsList.languageList.list.find(language => language.id === this.props.getValues("titleLanguage"))?.isoCode
        let title: ContentDescription = {
            language: isoCode ? isoCode : "",
            description: this.props.getValues("title")
        }

        let description: ContentDescription = {
            language: isoCode ? isoCode : "",
            description: this.props.getValues(`description`)
        };

        if (title.language !== "" && this.state.titles.some(obj => obj.language === title.language)) {
            this.setState(() => ({
                languageError: true,
            }));
            return
        }

        if (title.language === "" || !title.description || !description.description) {
            this.setState(() => ({
                titleError: true,
            }));
            return
        }

        this.setState(prevState => ({
            titles: [...prevState.titles, title],
            descriptions: [...prevState.descriptions, description]
        }));


        //this.props.setValue("titleLanguage", null);
        this.props.setValue("title", "")
        this.props.setValue("description", "")
    }

    private deleteTitle = (title: ContentDescription) => {

        this.setState(prevState => ({
            titles: prevState.titles.filter(item => (item.language !== title.language && item.description !== title.description))
        }));
    }

    private updateSelectedAwards = (list: string[]) => {
        this.setState(() => ({
            selectedAwards: list,
        }))
    }

    private updateSelectedFestivals = (list: string[]) => {
        this.setState(() => ({
            selectedFestivals: list,
        }))
    }

    private updateSelectedGenres = (list: string[]) => {
        this.setState(() => ({
            selectedGenres: list,
        }))
    }

    private updateSelectedTags = (list: string[]) => {
        this.setState(() => ({
            selectedTags: list,
        }))
    }

    private updateSelectedCountries = (list: string[]) => {
        this.setState(() => ({
            selectedCountries: list,
        }))
    }

    private updateSelectedLanguages = (list: string[]) => {
        this.setState(() => ({
            selectedLanguages: list,
        }))
    }

    private updateIsMenuEntryCheckbox = (): boolean => {

        this.setState(() => ({
            isMenuEntry: !this.state.isMenuEntry
        }))


        return this.state.isMenuEntry;
    }


    private parseFileImg = (event: any) => {
        this.setState(() => ({
            fileImg: event.target.files[0],
            fileImgName: event.target.files[0].name,
            fileImgURL: URL.createObjectURL(event.target.files[0]),
            isThumbUploaded: true,
            isThumbUpdated: true,
        }));
    };


    private removeFileImg = () => {
        this.setState(() => ({
            fileImg: null,
            fileImgName: null,
            isThumbUploaded: false
        }));
    };


    render() {
        return (
            <Box>
                {this.state.formFlag && <form onSubmit={this.props.handleSubmit(this.submitForm)}>
                    <Box
                        p={3}
                        borderRadius="5px"
                        bgcolor={process.env.REACT_APP_THIRD_COLOR}>

                        {this.state.titles.length > 0 && <Grid container>
                            <Grid item xs={12} md={6} color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}>
                                <List dense>
                                    {this.state.titles.map((title, i) =>
                                        <ListItem
                                            key={i}
                                            secondaryAction={
                                                <IconButton edge="end" aria-label="delete" onClick={() => this.deleteTitle(title)}>
                                                    <ClearIcon fontSize="small" sx={{ color: process.env.REACT_APP_DEFAULT_TEXT_COLOR }} />
                                                </IconButton>
                                            }
                                        >
                                            <ListItemIcon sx={{ minWidth: "35px" }}>
                                                <CircleIcon sx={{ width: "10px", height: "10px", color: process.env.REACT_APP_DEFAULT_TEXT_COLOR }} />
                                            </ListItemIcon>
                                            <ListItemText
                                                primary={
                                                    <Stack direction="row" spacing={5}>
                                                        <Typography
                                                            variant="caption"
                                                            maxWidth={250}
                                                            sx={{
                                                                whiteSpace: "nowrap",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                            }}>
                                                            {title.description}
                                                        </Typography>
                                                    </Stack>
                                                }
                                            />
                                        </ListItem>
                                    )}
                                </List>
                            </Grid>
                        </Grid>}
                        <Grid container columnSpacing={3} rowSpacing={1}>
                            <Grid item xs={4} mt={1}>
                                <ZPlayAutocomplete
                                    fieldName={`titleLanguage`}
                                    label={t({
                                        id: "caecl-title-language",
                                        message: "Lingua"
                                    })}
                                    formState={this.props.formState}
                                    control={this.props.control}
                                    trigger={this.props.trigger}
                                    data={this.state.languages}
                                    disabledOption={this.state.languages.filter(language => {
                                        return this.state.titles.some(title => title.language === language.id);
                                    })} />
                            </Grid>
                            <Grid item xs={12} md={7}>
                                <ZplayFormField
                                    label={t({
                                        id: "caecl-title",
                                        message: "Titolo"
                                    })}
                                    name={'title'}
                                    control={this.props.control}
                                    formState={this.props.formState}
                                    trigger={this.props.trigger}
                                />
                            </Grid>
                            <Grid item xs={1} mt={1} textAlign="right">
                                <Tooltip title="Aggiungi titolo" placement="right">
                                    <Fab size="small" color="primary" onClick={this.addTitle}>
                                        <AddIcon />
                                    </Fab>
                                </Tooltip>
                            </Grid>
                            <Grid item xs={12}>
                                <ZPlayMultilineTextField
                                    label={t({
                                        id: "caecl-description",
                                        message: "Descrizione"
                                    })}
                                    name={`description`}
                                    rows={2}
                                    maxLength={2048}
                                    control={this.props.control}
                                    formState={this.props.formState}
                                    trigger={this.props.trigger}
                                />
                            </Grid>
                        </Grid>
                        {this.state.titleError && <Stack direction="row" spacing={1} mb={2}>
                            <ErrorIcon fontSize="small" color="error" />
                            <Typography
                                variant={"body2"}
                                color="error">
                                <Trans id={"caecl-title-description-error"}>È necessario inserire la lingua, il titolo e una descrizione per poter aggiungere una traduzione.</Trans>
                            </Typography>
                        </Stack>}
                        {this.state.languageError && <Stack direction="row" spacing={1} mb={2}>
                            <ErrorIcon fontSize="small" color="error" />
                            <Typography
                                variant={"body2"}
                                color="error">
                                <Trans id={"caecl-title-description-language-error"}>Esiste già un titolo con la lingua selezionata.</Trans>
                            </Typography>
                        </Stack>}

                        <Grid container columnSpacing={3} rowSpacing={1} my={2}>
                            <Grid item xs={12} md={2}>
                                <ZplayFormField
                                    label={t({
                                        id: "caecl-priority",
                                        message: "Priorità"
                                    })}
                                    name={'priority'}
                                    control={this.props.control}
                                    formState={this.props.formState}
                                    trigger={this.props.trigger}
                                />
                            </Grid>
                            <Grid item xs={12} md={5}>
                                <ZplayDatePicker
                                    label={t({
                                        id: "caecl-featured-from",
                                        message: "In evidenza dal",
                                    })}
                                    name={`featuredFrom`}
                                    formState={this.props.formState}
                                    control={this.props.control}
                                    trigger={this.props.trigger}
                                />
                            </Grid>
                            <Grid item xs={12} md={5}>
                                <ZplayDatePicker
                                    label={t({
                                        id: "caecl-featured-to",
                                        message: "In evidenza fino al",
                                    })}
                                    name={`featuredTo`}
                                    formState={this.props.formState}
                                    control={this.props.control}
                                    trigger={this.props.trigger}
                                />
                            </Grid>
                        </Grid>

                        {/* UPLOAD ANTEPRIMA */}
                        <div style={{ paddingTop: "20px" }}>
                            <ThumbUpload
                                fileImgName={this.state.fileImgName}
                                fileImgURL={this.state.fileImgURL}
                                isThumbUploaded={this.state.isThumbUploaded}
                                removeFileImg={this.removeFileImg}
                                parseFileImg={this.parseFileImg}
                            />
                        </div>

                        <ZPlayChipList
                            chipsList={this.state.countries}
                            selectedChipsIds={this.state.selectedCountries}
                            color={process.env.REACT_APP_BACKOFFICE_CHIP_COLOR_COUNTRY}
                            updateListCallback={this.updateSelectedCountries}
                            title={"Paese"}
                            titleId={"caecl-country-label"}
                            textId={"caecl-country-explanation"}
                            text={"Scegli e seleziona i paesi sottostanti per aggiungerli alla content list."}
                            showCreate={false}
                        />
                        <ZPlayChipList
                            chipsList={this.state.languages}
                            selectedChipsIds={this.state.selectedLanguages}
                            color={process.env.REACT_APP_BACKOFFICE_CHIP_COLOR_LANGUAGE}
                            updateListCallback={this.updateSelectedLanguages}
                            title={"Lingua"}
                            titleId={"caecl-language-label"}
                            textId={"caecl-language-explanation"}
                            text={"Scegli e seleziona le lingue sottostanti per aggiungerle alla content list."}
                            showCreate={false}
                        />
                        <ZPlayChipList
                            chipsList={this.state.genres}
                            selectedChipsIds={this.state.selectedGenres}
                            color={process.env.REACT_APP_BACKOFFICE_CHIP_COLOR_GENRE}
                            updateListCallback={this.updateSelectedGenres}
                            title={"Genere"}
                            titleId={"caecl-genre-label"}
                            textId={"caecl-genre-explanation"}
                            text={"Scegli e seleziona i generi sottostanti per aggiungerli alla content list."}
                            showCreate={false}
                        />
                        <ZPlayChipList
                            chipsList={this.state.tags}
                            selectedChipsIds={this.state.selectedTags}
                            color={process.env.REACT_APP_BACKOFFICE_CHIP_COLOR_TAG}
                            updateListCallback={this.updateSelectedTags}
                            title={"Tag"}
                            titleId={"caecl-tag-label"}
                            textId={"caecl-tag-explanation"}
                            text={"Scegli e seleziona i tag sottostanti per aggiungerli alla content list."}
                            showCreate={false}
                        />
                        <ZPlayChipList
                            chipsList={this.state.awards}
                            selectedChipsIds={this.state.selectedAwards}
                            color={process.env.REACT_APP_BACKOFFICE_CHIP_COLOR_AWARD}
                            updateListCallback={this.updateSelectedAwards}
                            title={"Premi"}
                            titleId={"caecl-awards-label"}
                            textId={"caecl-award-explanation"}
                            text={"Scegli e seleziona i premi sottostanti per aggiungerli alla content list."}
                            showCreate={false}
                        />
                        <ZPlayChipList
                            chipsList={this.state.festival}
                            selectedChipsIds={this.state.selectedFestivals}
                            color={process.env.REACT_APP_BACKOFFICE_CHIP_COLOR_FESTIVAL}
                            updateListCallback={this.updateSelectedFestivals}
                            title={"Festival"}
                            titleId={"caecl-festival-label"}
                            textId={"caecl-festival-explanation"}
                            text={"Scegli e seleziona i festival sottostanti per aggiungerli alla content list."}
                            showCreate={false}
                        />
                        <Grid item xs={12} mt={8}>
                            <ZplayCheckbox
                                name={"isMenuEntry"}
                                label={t({
                                    id: "caecl-is-menu",
                                    message: "La content list farà parte del menù principale",
                                })}
                                onChange={() => this.updateIsMenuEntryCheckbox()}
                                formState={this.props.formState}
                                control={this.props.control}
                                trigger={this.props.trigger}
                            />
                        </Grid>
                    </Box>
                    <Grid item
                        xs={12}
                        mt={2}
                        textAlign={"right"}>
                        <Button
                            variant="contained"
                            color={"primary"}
                            disabled={this.props.formState.isSubmitting}
                            type="submit">
                            {this.props.contentList ?
                                <Trans id="caecl-submit-edit-button">Modifica</Trans> :
                                <Trans id="caecl-submit-create-button">Crea</Trans>}
                        </Button>
                    </Grid>
                </form>}
            </Box>
        );
    }
}


export default withUseFormHook<{}>(CreateAndEditContentList, CreateAndEditContentListFormSchema, {});
